import { useEffect } from 'react';
import Swiper from 'swiper';
import Header from '../components/Header'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import  '../Assets/js/generalui.js'
import  '../Assets/js/datetimefunc.js'
import  '../Assets/js/countrycode.js'
import  '../Assets/js/messagelang.js'
import  '../Assets/js/index.js'

window.Swiper = Swiper;

function Home()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("Index");
  }, []);

  // Append Body Element To 'root' -----------------------------------------------------
  return(
    <>
      <div className="basic">

        <Header/>

        <div className="TopBottomIndexSection TopIndexSection">
          <div className="MainBackgroundAnimateContainer" id="MainBackgroundAnimateContainer">
            <img style={{opacity: 0}} className="MainBackgroundAnimate" id="MainTopBackground" />
            <div className="loading_grey" style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}} id="LoadingTopBackground" />
            <div style={{backgroundColor: 'rgba(0, 0, 0, 0.2)', width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}} />
          </div>
          <p className="TopTextQuotes InterRegularTextFont" style={{textAlign: 'center'}} id="HeroBannerText">Temukan <span className="InterBoldTextFont">Pengalaman</span> dan <span className="InterBoldTextFont">Penginapan Unik</span> di Indonesia<br />Hanya di <span className="InterBoldTextFont">PinginGo</span></p>
          <div className='SearchIndexHomePageWrapper'>
            <div className="SearchHotelIndexFormContainer SlightlyBigMarginTopList">
              <div className="HoverableContentInsideInputField Unselectable" id="InputFieldSearchContainer">
                <div className="SearchHotelInputFieldContainerIndex BasicPadding BasicInputFieldContainer Selectable3">
                  <img src="/Assets/images/ButtonIcon/searchicon.svg" className="BasicIconInsideInput" style={{marginLeft: 0}} />
                  <div style={{flex: 1, display:"flex", flexDirection:"column", position:"relative"}}>
                    <p className="BasicInputTextBottom InterRegularTextFont" id="MauNginepDimanaHeaderInputText">Mau Nginap dimana?</p>
                    <input className="SearchHotelInputFieldIndex InterMediumTextFont" style={{width:"auto", margin:0}} type="text" placeholder="Bali" id="MainSearchInputField" province-slug="" current-inputed="" />
                  </div>
                </div>
              </div>
              <div className="CheckInOutRoomNumberContainer" id='CheckInOutQuotaWrapper'>
                <div className="HoverableContentInsideInputField Unselectable" id="CheckInDateInput" date={14} month={2} year={2025}>
                  <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                    <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{marginLeft: 0}} />
                    <div className="SearchInputFieldTopBottomTextWrapper">
                      <p className="BasicInputTextBottom InterRegularTextFont RoomUIDisplay" id="CheckInInputHeaderSearchText">Check-in</p>
                      <p className="BasicInputTextBottom InterRegularTextFont ExperienceUIDisplay" id="DateOfVisitSearchHeaderText" style={{display:"none"}}>Tanggal Berkunjung</p>
                      <p className="BasicInputTextTop InterBoldTextFont" id="CheckInDateInputDateText" style={{marginTop: 0}}>14 Sept 2023</p>
                      <p className="BasicInputTextBottom InterRegularTextFont" style={{display:"none"}} id="CheckInDateInputDayNameText">Thursday</p>
                    </div>
                  </div>
                </div>
                <div className="HoverableContentInsideInputField Unselectable RoomUIDisplay" id="CheckOutDateInput" date={15} month={2} year={2025}>
                  <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                    <img className="BasicIconInsideInput" src="/Assets/images/ButtonIcon/check-in-out-icon.svg" style={{transform: 'scaleX(-1)', marginLeft: 0}} />
                    <div className="SearchInputFieldTopBottomTextWrapper">
                      <p className="BasicInputTextBottom InterRegularTextFont" id="CheckOutInputHeaderSearchText">Check-out</p>
                      <p className="BasicInputTextTop InterBoldTextFont" id="CheckOutDateInputDateText" style={{marginTop: 0}}>14 Sept 2023</p>
                      <p className="BasicInputTextBottom InterRegularTextFont" style={{display:"none"}} id="CheckOutDateInputDayNameText">Thursday</p>
                    </div>
                  </div>
                </div>
                <div className="HoverableContentInsideInputField Unselectable" id="RoomQuotaInput" room-quota={1}>
                  <div className="SearchHotelInputFieldContainerIndex BasicInputFieldContainer Selectable3">
                    <img className="BasicIconInsideInput ExperienceUIDisplay" src="/Assets/images/ButtonIcon/three-people-black.svg" style={{marginLeft: 0, display:"none"}} />
                    <img className="BasicIconInsideInput RoomUIDisplay" src="/Assets/images/ButtonIcon/room-icon.svg" style={{marginLeft: 0}} />
                    <div className="SearchInputFieldTopBottomTextWrapper">
                      <p className="BasicInputTextBottom InterRegularTextFont ExperienceUIDisplay" style={{display:"none"}} id="JumlahTamuHeaderSearch">Jumlah Tamu</p>
                      <p className="BasicInputTextBottom InterRegularTextFont RoomUIDisplay" id="HowManyNightText">1 Night</p>
                      <p className="BasicInputTextTop InterBoldTextFont" style={{marginTop: 0}} id="RoomQuotaTextDisplay">1 Room</p>
                    </div>
                    <img src="/Assets/images/ButtonIcon/chevron.svg" className="BasicInputFieldChevronIconSearch ToggleArrow" id="RoomQuotaToggleArrow" style={{rotate: '0deg'}} />
                  </div>
                </div>
              </div>
              <div className="ContainerFlex" style={{bottom: 0}}>
                <button className="BasicTextButton BasicBoxShadow OrangeButton IndexSearchButton Selectable" id="SearchButtonIndex">
                  <img className="BasicIconInsideInput3 BasicMarginTopBottom" src="/Assets/images/ButtonIcon/search-white.svg" style={{ marginLeft: "0" }} />
                  <p className="InterMediumTextFont SearchButtonText BasicMarginTopBottom">Search</p>
                </button>
              </div>
            </div>
            <div className='TopFilterSearchHomeContainer'>
              <div className='TopFilterSearchHomewrapper SlightlyBigPaddingBalanced BasicRadius ColumnGapLong'>
                <label className="BasicButtonWithText OrangeButtonLabelOnSelected GreyButtonLabelNotSelected Selectable SoftGreyOutlineButtonUnselected SoftShadowUnselected" htmlFor='PenginapanHomeFilterButton'>
                  <input type="radio" className='TopHomeSearchFilterButton' this-value="Rooms" name="TopHomeSearchFilterButton" id="PenginapanHomeFilterButton" style={{display:"none"}} />
                  <div style={{width: "fit-content", height: "fit-content", display: "flex", margin: "auto"}}>
                    <img className='BasicIconInsideButton IconToHideOnChecked' src="/Assets/images/ButtonIcon/grey-bed-icon.svg" />
                    <img className='BasicIconInsideButton IconToShowOnChecked' src="/Assets/images/ButtonIcon/white-bed-icon.svg" />
                    <p className="InterBoldTextFont PenginapanText" style={{whiteSpace:"nowrap", textOverflow:"ellipsis", width:"100%", overflow:"hidden"}}>Penginapan</p>
                  </div>
                  <div className="RedBorderMaxDiscountHotelDetails2 BasicMarginTopBottom NoPaddingLeftRight" style={{width:0, opacity:0}}>
                    <p className="BasicInputTextBottom InterBoldTextFont" style={{color: "white", width:0}}>I</p>
                  </div>
                </label>
                <label className="BasicButtonWithText OrangeButtonLabelOnSelected GreyButtonLabelNotSelected Selectable ColumnGapBasic SoftGreyOutlineButtonUnselected SoftShadowUnselected" htmlFor='ExperienceHomeFilterButton'>
                  <input type="radio" className='TopHomeSearchFilterButton' this-value="Experiences" name="TopHomeSearchFilterButton" id="ExperienceHomeFilterButton" style={{display:"none"}} />
                  <div style={{width: "fit-content", height: "fit-content", display: "flex", margin: "auto"}}>
                    <img className='BasicIconInsideButton IconToHideOnChecked' src="/Assets/images/ButtonIcon/twin-star-grey-outline.svg" />
                    <img className='BasicIconInsideButton IconToShowOnChecked' src="/Assets/images/ButtonIcon/twin-star-white-outline.svg" />
                    <p className="InterBoldTextFont ExperienceText" style={{whiteSpace:"nowrap", textOverflow:"ellipsis", width:"100%", overflow:"hidden"}}>Experience</p>
                  </div>
                  <div className="RedBorderMaxDiscountHotelDetails2 BasicMarginTopBottom SoftPinkBackAndRedTextSelected SoftRedOutlineTextSelected" style={{backgroundColor: "rgb(252, 85, 85)"}}>
                    <p className="BasicInputTextBottom InterBoldTextFont" style={{color: "white", textShadow:"none"}}>New</p>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="MainContentSection" id="MainContentIndex">
          <div className="SectionSeparatorContainer LoginSekarangWarningSection" style={{paddingBottom: 0}}>
            <div className="OrangeWarningContainer BasicRadius HideOnMobile">
              <div style={{width: 'fit-content', height: 'fit-content', display: 'flex', margin: 'auto 0', flexDirection:'row'}}>
                <img src="/Assets/images/Icon/gift-box-login-sekarang.svg" className="BasicIconInsideOrangeContainer" style={{marginLeft: 0}} />
                <p className="LabelGreyHeaderSmallerText InterRegularTextFont" style={{margin: 'auto 0', color: '#344054'}}>Login Sekarang, Kumpulin Poin &amp; Liburan Hemat Berkali-kali!</p>
              </div>
              <div className="UserTopInfoWrapper SecondSectionLoginSekarang" style={{height: 'fit-content', width: 'fit-content', margin: 'auto', marginRight: 0}}>
                <button className="BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable" onClick={()=> window.InstantiateLoginPanel('')}>Masuk</button>
                <button className="BasicTextButton BasicBoxShadow SignInButtonTop Selectable" style={{color: '#475467', backgroundColor: 'transparent'}}>
                  <div style={{width: 'fit-content', height: 'fit-content', display: 'flex', margin: 'auto'}}>
                    <p>Selengkapnya</p>
                    <img src="/Assets/images/ButtonIcon/help-icon.svg" className="BasicIconInsideButton" style={{marginRight: 0}} />
                  </div>
                </button>
              </div>
            </div>
            <div className="OrangeWarningContainer BasicRadius ShowOnMobile" style={{flexDirection: 'column'}}>
              <div className="FirstSectionLoginSekarang">
                <img src="/Assets/images/Icon/gift-box-login-sekarang.svg" className="BasicIconInsideOrangeContainer" style={{marginLeft: 0}} />
                <div>
                  <p className="LabelGreyHeaderText InterMediumTextFont" style={{color: '#344054'}}>Login, Dapatkan Lebih!</p>
                  <p className="LabelGreyHeaderSmallerText InterRegularTextFont">Booking lebih cepat, kumpulkan poin dari setiap pesanan &amp; sharing, bonusnya bisa dipakai buat liburan berikutnya.</p>
                </div>
              </div>
              <div className="UserTopInfoWrapper SecondSectionLoginSekarang" style={{height: 'fit-content', width: '100%'}}>
                <button className="BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable" onClick={()=> window.InstantiateLoginPanel('')} style={{width: '100%'}}>Masuk</button>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="SlidePopUpContainer" style={{display: 'none'}}>
            <div className="SectionContentWrapper">
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="PopularAreasPanelContainer" id="SliderPopUpContainer">
                    <div className="swiper-wrapper">
                    </div>
                  </div>
                </div>
                <div className="PopularAreasLeftRightButtonContainer PaddingButtonLeft">
                  <button className="NextPreviousSwiperButton Selectable2 PopUpSlideButtonPrev" id="SwiperPopUpButtonPrev">
                    <img src="/Assets/images/ButtonIcon/chevron.svg" alt="" />
                  </button>
                </div>
                <div className="PopularAreasLeftRightButtonContainer PaddingButtonRight">
                  <button className="NextPreviousSwiperButton Selectable2 PopUpSlideButtonNext" id="SwiperPopUpButtonNext">
                    <img src="/Assets/images/ButtonIcon/chevron.svg" alt="" />
                  </button>
                </div>
              </div>
              <div className="swiper-pagination BasicYellowPaginationContainer swiper-pagination-clickable swiper-pagination-bullets">
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="PopularTopContainerLoading">
            <div className="SectionContentWrapper">
              <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad" />
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge PopularAreasMask">
                  <div className="PopularAreasPanelContainer">
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                    <div className="PopularAreasPanel Unselectable" style={{pointerEvents: 'none'}}>
                      <div className="PopularAreasInformationPanel">
                        <div className="PopularAreasImageContainer">
                          <div className="loading_grey ImageFullCover" />
                        </div>
                        <div className="loading_grey NameofHotelPopularAreaLoadGrey" />
                        <div className="loading_grey HowManyHotelLeftPopularAreaLoadGrey" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" style={{backgroundColor: '#FFFFFF'}}>
            <div className="SectionContentWrapper">
              <div>
                <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey BasicRoomHeaderTextLoad" />
                <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey FeaturedButtonLoad" />
              </div>
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer">
                    <div className="BasicHotelListPanelSwiperWrapper" style={{display: 'flex'}}>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" style={{backgroundColor: '#FFFFFF', display: 'none'}}>
            <div className="SectionContentWrapper">
              <p className="SectionHeaderTextIndex InterRegularTextFont">👍Rekomendasi Penginapan untuk Anda</p>
              <div className="ContainerWithMaskEdge">
                <div className="FeaturedButtonContainer">
                  <div className="swiper-wrapper">
                    <button className="FeaturedButtonIndex FeaturedButtonSelected InterBoldTextFont Selectable swiper-slide">Bali</button>
                    <button className="FeaturedButtonIndex InterBoldTextFont Selectable swiper-slide">Yogyakarta</button>
                    <button className="FeaturedButtonIndex InterBoldTextFont Selectable swiper-slide">Malang</button>
                  </div>
                </div>
              </div>
              <div className="NoFeaturedPropertyFoundContainer">
                <img src="/Assets/images/ButtonIcon/no-featured.svg" className="NoFoundIcon" />
                <p className="NoFoundHeaderText InterBoldTextFont">No Featured Property Found</p>
                <p className="NoFoundMessageText InterRegularTextFont">Featured property will come to this city</p>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="ExtraLoadingContent">
            <div className="SectionContentWrapper">
              <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey" style={{width: '20%'}} />
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer">
                    <div className="BasicHotelListPanelSwiperWrapper" style={{display: 'flex'}}>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer" id="ExtraLoadingContent2">
            <div className="SectionContentWrapper">
              <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey" style={{width: '20%'}} />
              <div className="BasicPanelSwiperMainContainer">
                <div className="ContainerWithMaskEdge">
                  <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer">
                    <div className="BasicHotelListPanelSwiperWrapper" style={{display: 'flex'}}>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                      <div className="RoomPanelContainer InterMediumTextFont">
                        <div className="RoomPanelContentWrapper">
                          <div className="RoomPanelImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="RoomPanelBottomInfoWrapper">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelNameInsidePanel loading_grey" style={{width: '100%'}} />
                            <div className="RoomHotelRightInfo1 loading_grey" style={{marginLeft: 'auto'}} />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft: 'auto'}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="SectionSeparatorContainer">
            <div className="SectionContentWrapper">
              <div className="DaftarkanContentContainer">
                <div className="move-rect">
                  <img/>
                </div>
                <div className="loading_grey ImageFullCover" />
                <div className="DaftarkanDescContainer">
                  <p className="SectionHeaderTextIndex2 InterMediumTextFont">Daftarkan Penginapan Anda di <img src="/Assets/images/Icon/pingingo-icon.svg" /></p>
                  <p className="LabelGreyHeaderSmallerText InterRegularTextFont">Perlihatkan Keindahan Alam Penginapan Anda: Jadilah Hidden Gem, Glamping, Villa, atau Resort dengan Pengalaman Menginap Tak Terlupakan</p>
                  <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable">
                    Gabung Sekarang
                    <a className="HREFInsideContainer ListingMitraButtons" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <RightPanelMobile/>

      <Footer/>
    </>
  )
}

export default Home